/**
 * Generated runtime TestId mirror for frontend/src/pages/IdentityDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

import {IdentityLifecycleState} from "../types/identity.ts";

export const IdentityDetailTestIds = {
  accountsSectionTitle: "accounts-section-title",
  assignmentRow: "assignment-row",
  badgeProcessing: "badge-processing",
  btnCreateAccount: "btn-create-account",
  btnEditReactivationDate: "btn-edit-reactivation-date",
  btnEvaluateRules: "btn-evaluate-rules",
  btnRehire: "btn-rehire",
  btnRetryInherited: "btn-retry-inherited",
  cardSectionDetails: "card-section-details",
  cardSectionFunctionGroups: "card-section-function-groups",
  cardSectionIdentifiers: "card-section-identifiers",
  cardSectionLifecycle: "card-section-lifecycle",
  colAccessProfiles: "col-access-profiles",
  colActions: "col-actions",
  colCreatedAt: "col-created-at",
  colExpand: "col-expand",
  colExpiresAt: "col-expires-at",
  colExternalIdentifier: "col-external-identifier",
  colFgActions: "col-fg-actions",
  colFgExpand: "col-fg-expand",
  colFgExpiresAt: "col-fg-expires-at",
  colFgSources: "col-fg-sources",
  colFgStatus: "col-fg-status",
  colFunctionGroup: "col-function-group",
  colIdentifierPrimary: "col-identifier-primary",
  colIdentifierType: "col-identifier-type",
  colIdentifierValidFrom: "col-identifier-valid-from",
  colIdentifierValidTo: "col-identifier-valid-to",
  colIdentifierValue: "col-identifier-value",
  colSources: "col-sources",
  colStatus: "col-status",
  colTargetSystem: "col-target-system",
  fieldDisplayName: "field-display-name",
  fieldReactivationDate: "field-reactivation-date",
  identifiersEmpty: "identifiers-empty",
  identityDetailPage: "identity-detail-page",
  inheritedAssignmentRow: "inherited-assignment-row",
  inputEditReactivationDate: "input-edit-reactivation-date",
  inputLifecycleReason: "input-lifecycle-reason",
  inputRehireNewEntryDate: "input-rehire-new-entry-date",
  inputRehireReason: "input-rehire-reason",
  inputSuspendReactivationDate: "input-suspend-reactivation-date",
  lifecycleReasonCounter: "lifecycle-reason-counter",
  lifecycleSectionHeader: "lifecycle-section-header",
  lifecycleStateBadge: "lifecycle-state-badge",
  linkPartyDetail: "link-party-detail",
  sectionAccessProfiles: "section-access-profiles",
  sectionAttributes: "section-attributes",
  sectionParty: "section-party",
  selectTargetSystem: "select-target-system",
  tabLifecycle: "tab-lifecycle",
  tabTimeline: "tab-timeline",
  badgeLifecycleState: (subtype: IdentityLifecycleState) => `badge-lifecycle-state-${subtype}` as const,
  badgeLifecycleStatePrefix: () => "badge-lifecycle-state-" as TestIdPrefix,
  btnLifecycle: (subtype: IdentityLifecycleState) => `btn-lifecycle-${subtype}` as const,
  btnLifecyclePrefix: () => "btn-lifecycle-" as TestIdPrefix,
  accountRow: (account_id: string) => `account-row-${account_id}`,
  accountRowPrefix: () => "account-row-" as TestIdPrefix,
  assignmentStatus: (inherited_status: string) => `assignment-status-${inherited_status}`,
  assignmentStatusPrefix: () => "assignment-status-" as TestIdPrefix,
  btnDeleteAccount: (account_id: string) => `btn-delete-account-${account_id}`,
  btnDeleteAccountPrefix: () => "btn-delete-account-" as TestIdPrefix,
  btnDisableAccount: (account_id: string) => `btn-disable-account-${account_id}`,
  btnDisableAccountPrefix: () => "btn-disable-account-" as TestIdPrefix,
  btnEnableAccount: (account_id: string) => `btn-enable-account-${account_id}`,
  btnEnableAccountPrefix: () => "btn-enable-account-" as TestIdPrefix,
  btnProvisionNow: (account_id: string) => `btn-provision-now-${account_id}`,
  btnProvisionNowPrefix: () => "btn-provision-now-" as TestIdPrefix,
  btnRevokeAssignment: (assignment_id: string) => `btn-revoke-assignment-${assignment_id}`,
  btnRevokeAssignmentPrefix: () => "btn-revoke-assignment-" as TestIdPrefix,
  btnRevokeFgAssignment: (fgAssignment_id: string) => `btn-revoke-fg-assignment-${fgAssignment_id}`,
  btnRevokeFgAssignmentPrefix: () => "btn-revoke-fg-assignment-" as TestIdPrefix,
  eventType: (event_eventType: string) => `event-type-${event_eventType}`,
  eventTypePrefix: () => "event-type-" as TestIdPrefix,
  fgAssignmentRow: (fgAssignment_functionGroupId: string) => `fg-assignment-row-${fgAssignment_functionGroupId}`,
  fgAssignmentRowPrefix: () => "fg-assignment-row-" as TestIdPrefix,
  fgAssignmentStatus: (fgAssignment_status: string) => `fg-assignment-status-${fgAssignment_status}`,
  fgAssignmentStatusPrefix: () => "fg-assignment-status-" as TestIdPrefix,
  identifierPrimary: (idf_id: string) => `identifier-primary-${idf_id}`,
  identifierPrimaryPrefix: () => "identifier-primary-" as TestIdPrefix,
  identifierRow: (idf_id: string) => `identifier-row-${idf_id}`,
  identifierRowPrefix: () => "identifier-row-" as TestIdPrefix,
  inheritedSourceBadge: (inherited_functionGroup_id: string) => `inherited-source-badge-${inherited_functionGroup_id}`,
  inheritedSourceBadgePrefix: () => "inherited-source-badge-" as TestIdPrefix,
  linkAccessProfile: (assignment_accessProfileId: string) => `link-access-profile-${assignment_accessProfileId}`,
  linkAccessProfilePrefix: () => "link-access-profile-" as TestIdPrefix,
  linkFgDetail: (fgAssignment_functionGroupId: string) => `link-fg-detail-${fgAssignment_functionGroupId}`,
  linkFgDetailPrefix: () => "link-fg-detail-" as TestIdPrefix,
  linkInheritedAp: (inherited_accessProfile_id: string) => `link-inherited-ap-${inherited_accessProfile_id}`,
  linkInheritedApPrefix: () => "link-inherited-ap-" as TestIdPrefix,
  linkInheritedViaFg: (inherited_functionGroup_id: string) => `link-inherited-via-fg-${inherited_functionGroup_id}`,
  linkInheritedViaFgPrefix: () => "link-inherited-via-fg-" as TestIdPrefix,
  linkRuleDetail: (source_ruleId: string) => `link-rule-detail-${source_ruleId}`,
  linkRuleDetailPrefix: () => "link-rule-detail-" as TestIdPrefix,
  linkSystemDetail: (account_targetSystem_id: string) => `link-system-detail-${account_targetSystem_id}`,
  linkSystemDetailPrefix: () => "link-system-detail-" as TestIdPrefix,
  sourceBadge: (source_id: string) => `source-badge-${source_id}`,
  sourceBadgePrefix: () => "source-badge-" as TestIdPrefix
} as const;
